import React from "react";
import EditorNumber from "./numbers/EditorNumber";

const StakeSelector = (props) => {

    const onClickNumber = (selected) => {
        selected = parseInt(selected.substring(0, selected.length-1));
        selected = selected * 100;
        props.onSelect(selected);
    };
    const createSelections = () => {
        var result = props.stakes.map((s) => <EditorNumber key={s} onClickNumber={(selected) => onClickNumber(selected)} className="smallNumber lineHeight5" number={s/100 + "€"} selected={props.stake === s}></EditorNumber>);
        return result;
    };
    return (
        <div className="grid5">
            {createSelections()}     
        </div>
    );
};

export default StakeSelector;